export default __webpack_public_path__ + "static/footer_background-ac82b0a23ed4979a9664cccf3a88f768.png";